import {DtrumApi} from '@dynatrace/dtrum-api-types';

const dynatrace: DtrumApi | undefined = (window as any).dtrum ? ((window as any).dtrum as DtrumApi) : undefined;

export const reportError = (error: Error) => {
  dynatrace?.reportError(error);
};
